// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"793":"0cf02857","879":"13cbab3a","936":"ee6eebf7","939":"6a78bc87"}[chunkId] + ".css";
};